var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMailFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_1611)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00039 4H22.0002V6.28571V17.7143V20H2C2 20 2.00025 18.9767 2.00025 17.7143V6.28571L2.00039 4ZM6.41603 8.37596L5.79199 7.95994L4.95994 9.20801L5.58397 9.62404L11.584 13.624L12 13.9014L12.416 13.624L18.416 9.62404L19.0401 9.20801L18.208 7.95994L17.584 8.37596L12 12.0986L6.41603 8.37596Z",
    fill: "#020617"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_1611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailFull);
export default __webpack_public_path__ + "static/media/icon-mail-full.2df75d2dfe39c9077214ecee8370be5d.svg";
export { ForwardRef as ReactComponent };